import { Button, Popconfirm, Tag } from "antd";

export const formLayout = { labelCol: { span: 8 }, wrapperCol: { span: 16 }, colon: false };

export const saveButton = (loading, onClick) => <Button 
  type="primary" 
  className="misoft-btn" 
  loading={loading} 
  disabled={loading}
  onClick={onClick}>
    Сохранить
  </Button>

export const deleteButton = (loading, id, onDelete) => <Popconfirm 
  title="Удалить?"
  description="Действие нельзя отменить"
  okText="Удалить"
  cancelText="Отмена"
  onConfirm={onDelete} 
  okButtonProps={{ danger: true }}
  >
  <Button danger className="misoft-btn" disabled={!id} loading={loading}>Удалить</Button>
</Popconfirm>

export const refreshButton = (onClick) => <Button className="misoft-btn" onClick={onClick}>Обновить</Button>

export const statuses = [
  { value: 0, label: "Новый", color: "gray" },
  { value: 10, label: "Обработка", color: "blue" },
  { value: 20, label: "Принят", color: "purple" },
  { value: 30, label: "Производство", color: "orange" },
  { value: 40, label: "Готов", color: "green" },
  { value: 50, label: "Отгружен", color: "blue" },
  { value: 60, label: "Отменен", color: "red" },
]

export const statusTag = status => {
  const statusItem = statuses.find(i => i.value === status);
  if (!statusItem) return null;
  return <Tag color={statusItem.color}>{statusItem.label}</Tag>;
}